import { useTranslation } from 'next-i18next';
import { ISupplier } from '@bridebook/models/source/models/Suppliers.types';
import { Box } from '@bridebook/ui';
import { IconExperience } from '@bridebook/ui/src/icons';
import InfoBlock from '@bridebook/web/app-shared/components/supplier/sections/info-block/info-block';
import SectionHeading from '@bridebook/web/app-shared/components/supplier/sections/section-heading';
import { supplierDetailsList } from '@bridebook/web/app-shared/lib/supplier/supplier-details-list';
import componentStyles from '@bridebook/web/app-basic/components/supplier/sections/experience/experience.style';

interface ExperienceProps {
  supplier?: ISupplier;
}

const Experience = ({ supplier }: ExperienceProps) => {
  const { t } = useTranslation('supplier');

  const styles = componentStyles();

  return (
    <Box style={styles.wrapper}>
      <SectionHeading largeMargin>
        <Box style={styles.iconWrap}>
          <IconExperience color="indigoCrush" />
        </Box>
        <Box>{t('supplier.experience.title')}</Box>
      </SectionHeading>

      <Box style={styles.contentWrap}>
        <InfoBlock items={supplierDetailsList} supplier={supplier} />
      </Box>
    </Box>
  );
};

export default Experience;
